/* ============
 * Actions for the filters module
 * ============
 *
 * The actions that are available on the
 * account module.
 */

import axios from 'axios';
import { apiEndpointConst, authHeader } from '@/utils/urls';
import * as types from './mutation-types';

export default {
  load, addFilter, clearFilters,
};

function apiEndpoint(order, lang) {
  let result = `/api-proxy/${order}/data/filter${lang ? `?lang=${lang}` : ''}`;

  if (process.env.NODE_ENV === 'production') {
    result = apiEndpointConst(order, 'filter', lang ? `?lang=${lang}` : '');
  }

  return result;
}

export function load({ commit }, { order, lang }) {
  return axios
    .get(apiEndpoint(order, lang), { headers: authHeader })
    .then((res) => {
      commit(types.LOAD, res.data);
      return res.data;
    });
}

export function addFilter({ commit }, filter) {
  commit(types.ADD, filter);
  return Promise.resolve(filter);
}

export function clearFilters({ commit }) {
  commit(types.CLEAR);
  return Promise.resolve();
}

